export default "__VITE_ASSET__18fbf32e__"